export default {
  featuredExperiences: 'Experências sugeridas',
  searchAllExperiences: 'Procure todas as experiências',
  searchAll: 'Procurar tudo',
  groupSize: 'Dimensão do grupo',
  eventSize: 'Dimensão do evento',
  upTo: 'Até',
  whatWeDo: 'Coisas a fazer',
  hostedBy: 'Oferecido por',
  whatsIncluded: 'O que está incluído',
  avail: 'Disponibilidade',
  whereWeAre: 'Onde estaremos',
  experienceCalendar: 'Calendário de Experiência',
  experienceCancelled: 'Experiência Cancelada',
  experienceStartingPrice: 'Desde',
  experienceTotalPrice: 'Total',
  at: 'em',
  viewPrivateSessAvailability: 'Ver disponibilidade de sessões privadas',
  selectSession: 'Selecionar sessão',
  sessionsCount: '{{count}} horários — escolha um horário',
  noAvailability: 'Sem disponibilidade',
  select: 'Selecionar',
  slotLeft: 'vaga disponível',
  slotsLeft: 'vagas disponíveis',
  spotsLeft: '{{count}} restantes',
  spotsLeftAriaLabel: '{{count}} vagas restantes',
  bookExperience: 'Reservar experiência',
  book: 'Reservar',
  learnMore: 'Saiba mais',
  maxPartySizes: 'Número máximo de vagas por grupo',
  maxPartySize: 'Número máximo de vagas por grupo',
  selectSessionValidation: 'Selecionar a sessão',
  selectParticipantValidation: 'Selecionar participantes',
  selectDateValidation: 'Selecionar data',
  reminders: 'Lembretes',
  seeOtherDates: 'Ver outras datas',
  location: 'Localização',
  about: 'Sobre',
  allExperiences: 'Todas as experiências',
  soldOut: 'Esgotado',
  reviews: 'Avaliações',
  reviewSingular: 'Avaliar',
  reviewPlural: 'Avaliações',
  dateOfExperience: 'Data da experiência',
  readLess: 'Ler menos',
  readMore: 'Ler mais',
  seeMore: 'Ver mais',
  details: 'Detalhes',
  durationHour: 'hora',
  durationHours: 'horas',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'Este vídeo não contém áudio',
  by: 'Por',
  chooseATime: 'Escolha um horário para {{title}}',
  amenities: 'Amenidades',
  ticketSalesOpenIn: 'Venda de ingressos começa em',
  ticketSalesOpen: 'Venda de ingressos aberta',
  ticketSalesCloseIn: 'Venda de ingressos termina em',
  ticketSalesClose: 'Venda de ingressos encerrada',
  ticketSalesClosed: 'Venda de ingressos encerrada',
  comingSoon: 'Em breve',
  inPartnershipWith: 'Em parceria com',
  notFoundExperienceTitle: 'Esta experiência não está mais disponível',
  notFoundExperienceSubtitle:
    'Pode ter sido despublicada ou o link pode não ser mais válido.',
  deadLinkRecoverySubtitle:
    'Descubra outras experiências disponíveis para reserva',
  viewAllExperiences: 'Ver todas as experiências',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Ganhe 5 Pontos Base</strong> por cada 1 USD qualificado gasto ao fazer login na sua conta World of Hyatt para reservar esta experiência</p>',
      basePoints:
        '<p><strong>Ganhe 10 Pontos Base</strong> por cada 1 USD qualificado gasto ao fazer login na sua conta World of Hyatt para reservar esta experiência</p>',
      additionalBonusPoints:
        '<p><strong>Ganhe 4 Pontos Bônus adicionais</strong> por cada 1 USD qualificado gasto ao reservar com seu Cartão de Crédito World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Ganhe até 30% de Pontos Bônus adicionais</strong> dependendo do seu status de nível</p>',
      payWithPoints:
        '<p><strong>Pague com Pontos</strong> ao reservar esta experiência</p>',
    },
  },
};
